import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ContractorDto } from "./human-resource-agent.dto";

export class ContractResponseModel extends GlobalResponseObject{
    data?: ContractorDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ContractorDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}